import { VendorPageStep } from 'src/pages/VendorsPage/VendorsPage.context.types';
import type { IProductSpecificationReference } from 'src/types/reference/IProductSpecificationReference';
import { ProductSpecificationFieldGroup } from 'src/types/reference/ProductSpecificationFieldGroup';
import type { IVendorLeadProduct } from 'src/types/vendors/IVendorLeadProduct';

export function isVendorStepStarted(
  step: VendorPageStep,
  vendorLeadProduct: IVendorLeadProduct | null,
  productTypeSpecification: IProductSpecificationReference | null
): boolean {
  if (vendorLeadProduct) {
    if (step === VendorPageStep.Pictures) {
      return vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.Pictures);
    }

    if (step === VendorPageStep.Description) {
      return (
        vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.Quantities) ||
        vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.ProductDetails) ||
        vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.ShippingDetails)
      );
    }

    if (step === VendorPageStep.Condition) {
      const allowSdsFiles = !!productTypeSpecification?.allowSdsFiles;

      return (
        vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.Condition) ||
        (allowSdsFiles && vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.SdsFiles))
      );
    }

    if (step === VendorPageStep.Contact) {
      return (
        vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.Contacts) ||
        vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.ShippingAddress) ||
        vendorLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.BillingAddress)
      );
    }
  }

  return false;
}
